import { GumVarHelper } from '../models';

/**
 * Returns formatted CSS variable name
 * @param prefix CSS variable prefix
 * @param key variation (custom name)
 */
export const getVarName: GumVarHelper = (prefix, key?) =>
  key ? `--${prefix}-${key}` : `--${prefix}`;

/**
 * Returns CSS variable value with var()
 * @param prefix CSS variable prefix
 * @param key variation (custom name)
 */
export const getVarValue: GumVarHelper = (prefix, key) =>
  `var(${getVarName(prefix, key)})`;
